// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluationClaimCard-cls1_4xl","cls2":"EvaluationClaimCard-cls2_fAA EvaluationClaimCard-cls1_4xl"};